/* AME configurator UI — presentation layer for the Customize & Buy panel (2026-09-27 revamp).
 *
 * ★ PROXY, NEVER A SECOND SOURCE OF TRUTH. ame-pdp-state.js owns pricing, compatibility, validation and the
 *   cart POST, and reads only the native controls. Everything here drives those controls the way a shopper would
 *   (select.value + a 'change' on THAT select; .click() on fabric options) and re-reads them after every change,
 *   because the engine flips option.disabled / snaps values without firing events. Proxy elements use data-ui-*
 *   attributes only, so no engine selector (data-addon-*, data-fabric-option, …) ever matches them.
 *   Without JS the native controls render exactly as before.
 */
(function () {
  'use strict';
  var panel = document.querySelector('[data-customize-panel]');
  if (!panel) return;
  var MAX_CARDS = 8;   // 2026-10-10: 2–8 options become cards; 9+ keep the styled native select (a dropdown suits long lists)
  var uid = 0;
  var money = function (cents) {
    var v = (cents || 0) / 100;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var syncers = [];
  var scheduled = false;
  var syncAll = function () {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(function () { scheduled = false; syncers.forEach(function (fn) { try { fn(); } catch (e) { /* keep the rest in sync */ } }); });
  };

  /* ---------------- option cards for small selects ---------------- */
  var labelFor = function (sel) {
    var l = sel.id ? panel.querySelector('label[for="' + sel.id + '"]') : null;
    if (!l) { var row = sel.closest('.ame-customize__row, [data-option-row]'); l = row && row.querySelector('label, .ame-customize__label, legend'); }
    if (l && !l.id) l.id = 'ui-lbl-' + (++uid);
    return l;
  };
  /* ★ THE CARD NAME IS THE OPTION'S OWN TITLE, WHOLE (2026-10-01). The old rule cut every name at the first " — "
       to drop the price suffix Liquid appends to the option TEXT ("Label — +$172.00"). But data-title never carries
       that suffix, and real labels contain the dash: on the PL400H five cards all read "U-Sling No Head" (Padded Med /
       Padded Large / … lost), the Amigo lift seats lost "250 lb maximum", and the EVO 613 heel loops had to be
       relabelled in DATA (tc04) to stay distinguishable. Only option TEXT without a data-title is still cut. */
  var optName = function (o) {
    var t = (o.getAttribute('data-title') || '').trim();
    if (!t) t = (o.textContent || '').trim().split(' — ')[0];
    return t.replace(/\s*\(included\)\s*$/i, '').trim();
  };
  /* ★ ONE CARD POLICY (2026-10-10, PDP UX standardization). Until this round the LAYOUT was decided by the option COUNT
       (a grid up to 3 options, a vertical list from 4, the native select above 6), so a three-size chair showed a grid,
       a six-size chair a column and a seven-size chair a dropdown. Layout now follows content and space:
         · every select with 2–8 real options becomes cards; 9+ keep the styled native select; the Liquid-rendered
           radio cards (≤4 variants, ame-product-customize) share the same CSS (ame-configurator-ui.css);
         · DENSE content — a secondary fit line (the size guide), a name over ~18 characters, or an add-on whose
           choices are sentences — renders as single-column rows: name + fit line left, price right;
         · SHORT names flow into an auto-fill grid whose column count comes from the CONTAINER width (one column
           under ~300px, two in the purchase rail) — CSS decides from the available room, never from the count;
         · one price vocabulary: "Base price" (the lowest-priced variant), "+$X" (a real differential),
           "No added cost" ($0 add-on choice), "Call for quote", "Sold out" / "Unavailable". */
  var reqMark = function (lbl) {
    if (!lbl || lbl.querySelector('.ui-req')) return;
    var s = document.createElement('span'); s.className = 'ui-req'; s.textContent = 'Required';
    lbl.appendChild(document.createTextNode(' ')); lbl.appendChild(s);
  };
  var enhanceSelect = function (sel, kind) {
    var opts = Array.prototype.filter.call(sel.options, function (o) { return o.value !== '' || !o.disabled; });
    var real = opts.filter(function (o) { return o.value !== ''; });
    var lbl = labelFor(sel);
    if (sel.hasAttribute('data-required-choice') || sel.hasAttribute('data-addon-required-group') || sel.hasAttribute('data-lineitem-required')) reqMark(lbl);
    if (real.length < 2 || real.length > MAX_CARDS) return;
    var base = null;
    if (kind === 'variant') real.forEach(function (o) { var p = parseInt(o.getAttribute('data-price') || '0', 10) || 0; if (base === null || p < base) base = p; });
    var cleanName = function (o) { return optName(o).replace(/\s*\(sold out\)\s*$/i, '').replace(/\s*—\s*currently unavailable\s*$/i, '').trim(); };
    var noteFor = function (o) {   // the size-guide fit line Liquid appends to a variant option's TEXT after " — "
      if (kind !== 'variant' || o.getAttribute('data-title')) return '';
      var t = (o.textContent || '').replace(/\s*\(sold out\)\s*$/i, '').trim(); var i = t.indexOf(' — ');
      return i > -1 ? t.slice(i + 3).trim() : '';
    };
    var dense = kind === 'addon' || real.some(function (o) { return cleanName(o).length > 18 || noteFor(o); });
    var group = document.createElement('div');
    group.className = 'ui-optcards' + (dense ? ' ui-optcards--list' : '');
    group.setAttribute('role', 'radiogroup');
    if (lbl) group.setAttribute('aria-labelledby', lbl.id); else group.setAttribute('aria-label', sel.getAttribute('data-group-label') || 'Option');
    group.setAttribute('data-ui-proxy', sel.id || ''); group.setAttribute('data-ui-kind', kind);
    var cards = real.map(function (o) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ui-optcard' + (dense ? ' ui-optcard--list-row' : '');
      b.setAttribute('role', 'radio'); b.setAttribute('data-ui-value', o.value);
      var main = document.createElement('span'); main.className = 'ui-optcard__main';
      var n = document.createElement('span'); n.className = 'ui-optcard__name'; n.textContent = cleanName(o); main.appendChild(n);
      var note = noteFor(o);
      if (note) { var nt = document.createElement('span'); nt.className = 'ui-optcard__note'; nt.textContent = note; main.appendChild(nt); }
      b.appendChild(main);
      var cents = parseInt(o.getAttribute('data-price') || '0', 10) || 0, priceText = '', inc = false;
      if (o.disabled && /sold out|unavailable/i.test(o.textContent)) priceText = 'Sold out';
      else if (kind === 'variant') { if (cents - base > 0) priceText = '+' + money(cents - base); else { priceText = 'Base price'; inc = true; } }
      else if (kind === 'addon') {
        if (/call for quote/i.test(o.textContent)) priceText = 'Call for quote';
        else if (o.value === '0' || cents === 0) { priceText = 'No added cost'; inc = true; }
        else priceText = '+' + money(cents);
      }
      if (priceText) { var p = document.createElement('span'); p.className = 'ui-optcard__price' + (inc ? ' ui-optcard__price--inc' : ''); p.textContent = priceText; b.appendChild(p); }
      b.addEventListener('click', function () {
        if (o.disabled) return;
        if (sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        syncAll();
      });
      group.appendChild(b);
      return { b: b, o: o };
    });
    group.addEventListener('keydown', function (e) {
      var keys = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
      if (!(e.key in keys)) return;
      e.preventDefault();
      var live = cards.filter(function (c) { return !c.o.disabled && !c.b.hidden; });
      var i = live.findIndex(function (c) { return c.b === document.activeElement; });
      var next = live[(i + keys[e.key] + live.length) % live.length];
      if (next) { next.b.focus(); next.b.click(); }
    });
    sel.classList.add('ui-visually-hidden'); sel.setAttribute('aria-hidden', 'true'); sel.tabIndex = -1;
    // the engine's submit errors focus the native control — send that focus to the visible card group instead
    sel.addEventListener('focus', function () {
      var c = cards.filter(function (x) { return x.b.tabIndex === 0; })[0] || cards[0];
      if (c) c.b.focus();
    });
    sel.insertAdjacentElement('afterend', group);
    var sync = function () {
      var any = false;
      cards.forEach(function (c) {
        var on = sel.value === c.o.value;
        c.b.setAttribute('aria-checked', on ? 'true' : 'false');
        c.b.setAttribute('aria-disabled', c.o.disabled ? 'true' : 'false');
        c.b.hidden = !!c.o.hidden;
        c.b.tabIndex = on ? 0 : -1; if (on) any = true;
        // the engine marks a child that can no longer be bought (data-unavailable, ame-pdp-state childAvail): say so on the card
        var pe = c.b.querySelector('.ui-optcard__price');
        if (pe) {
          if (c.o.disabled && c.o.getAttribute('data-unavailable') === 'true') { if (!pe.getAttribute('data-ui-orig')) pe.setAttribute('data-ui-orig', pe.textContent); pe.textContent = 'Unavailable'; }
          // 2026-10-13: a choice the engine disables because it does not fit another selection (heel loops ↔ leg rest,
          // data-compat) said only its price, struck through — say why instead
          else if (c.o.disabled && c.o.getAttribute('data-compat')) { if (!pe.getAttribute('data-ui-orig')) pe.setAttribute('data-ui-orig', pe.textContent); pe.textContent = 'Not compatible'; }
          else if (pe.getAttribute('data-ui-orig')) { pe.textContent = pe.getAttribute('data-ui-orig'); pe.removeAttribute('data-ui-orig'); }
        }
      });
      if (!any) { var f = cards.filter(function (c) { return !c.o.disabled && !c.b.hidden; })[0]; if (f) f.b.tabIndex = 0; }
      group.hidden = sel.closest('[hidden]') !== null && !group.closest('[hidden]');
    };
    new MutationObserver(syncAll).observe(sel, { subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden'] });
    syncers.push(sync); sync();
  };
  panel.querySelectorAll('select[data-addon-select]').forEach(function (s) { enhanceSelect(s, 'addon'); });
  panel.querySelectorAll('select[data-lineitem-select], select[data-extra-option]').forEach(function (s) { enhanceSelect(s, 'plain'); });
  panel.querySelectorAll('select[data-variant-select]').forEach(function (s) { enhanceSelect(s, 'variant'); });

  /* ---------------- fabric drawer ---------------- */
  var picker = panel.querySelector('[data-fabric-picker]');
  var trigger = picker && picker.querySelector('[data-fabric-picker-trigger]');
  var list = picker && picker.querySelector('[data-fabric-picker-panel]');
  if (picker && trigger && list && typeof HTMLDialogElement === 'function') {
    var options = Array.prototype.slice.call(list.querySelectorAll('[data-fabric-option]'));
    var dlg = document.createElement('dialog');
    dlg.className = 'ui-drawer ui-drawer--fabric'; dlg.setAttribute('aria-labelledby', 'ui-fabric-title');
    dlg.innerHTML = '<div class="ui-drawer__head"><h2 class="ui-drawer__title" id="ui-fabric-title"></h2>' +
      '<button type="button" class="ui-drawer__close" data-ui-close aria-label="Close">×</button></div><div class="ui-drawer__body"></div>';
    dlg.querySelector('#ui-fabric-title').textContent = 'Choose upholstery (' + options.length + ' fabrics)';
    dlg.querySelector('.ui-drawer__body').appendChild(list);
    picker.appendChild(dlg);                                   // stays inside [data-fabric-picker]: the engine's outside-click rule still holds
    picker.classList.add('ui-fabric--drawer');
    trigger.setAttribute('aria-haspopup', 'dialog');
    var thumbs = false;
    var open = function () {
      if (!thumbs) {   // swatch thumbnails only once the drawer is first opened (no image requests before)
        thumbs = true;
        options.forEach(function (o) {
          var sw = o.getAttribute('data-fabric-swatch'); if (!sw || o.querySelector('.ui-fabric-thumb')) return;
          var t = document.createElement('span'); t.className = 'ui-fabric-thumb'; t.setAttribute('aria-hidden', 'true');
          t.style.backgroundImage = 'url("' + sw.replace(/"/g, '') + '")'; o.insertBefore(t, o.firstChild);
        });
      }
      list.hidden = false; trigger.setAttribute('aria-expanded', 'true');
      if (!dlg.open) dlg.showModal();
      var cur = list.querySelector('[aria-selected="true"]') || options[0];
      if (cur) cur.focus({ preventScroll: false });
    };
    var shut = function () { if (dlg.open) dlg.close(); };
    picker.addEventListener('click', function (e) {
      if (e.target.closest('[data-fabric-picker-trigger]')) { e.stopImmediatePropagation(); e.preventDefault(); open(); }
    }, true);
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-ui-close]')) shut(); });
    dlg.addEventListener('close', function () { list.hidden = true; trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); });
    new MutationObserver(function () { if (list.hidden && dlg.open) shut(); }).observe(list, { attributes: true, attributeFilter: ['hidden'] });
    // Recommended swatches inline (names, not colour alone): the merch "Recommended" group, else the first included fabrics.
    var selectable = options.filter(function (o) { return o.getAttribute('data-fabric-chargeable') !== 'false'; });
    var rec;
    if (selectable.length <= 8) rec = selectable;                    // small programmes: every fabric, inline, by name
    else {
      rec = options.filter(function (o) { return o.closest('[data-fabric-merch="recommended"], .ame-fabric-picker__merch--recommended'); });
      if (!rec.length) rec = selectable.filter(function (o) { return (parseInt(o.getAttribute('data-fabric-upcharge-cents') || '0', 10) || 0) === 0; });
      rec = rec.slice(0, 6);
    }
    if (rec.length >= 2) {
      var row = document.createElement('div');
      row.className = 'ui-swatchrow'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', rec.length === selectable.length ? 'Fabrics' : 'Popular fabrics');
      var chips = rec.map(function (o) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ui-swatch'; b.setAttribute('data-ui-fabric', o.getAttribute('data-fabric-name') || '');
        var sw = o.getAttribute('data-fabric-swatch');
        b.innerHTML = '<span class="ui-swatch__img" aria-hidden="true"></span><span class="ui-swatch__name"></span>';
        if (sw) b.firstChild.style.backgroundImage = 'url("' + sw.replace(/"/g, '') + '")';
        b.lastChild.textContent = o.getAttribute('data-fabric-name') || '';
        b.addEventListener('click', function () { o.click(); syncAll(); });
        row.appendChild(b); return { b: b, o: o };
      });
      if (options.length > rec.length) {
        var all = document.createElement('button'); all.type = 'button'; all.className = 'ui-btn ui-btn--link ui-swatchrow__all';
        all.textContent = 'View all ' + options.length + ' fabrics'; all.addEventListener('click', open);
        row.appendChild(all);
      }
      picker.insertAdjacentElement('afterend', row);
      syncers.push(function () {
        var name = (panel.querySelector('[data-fabric-selected-name]') || {}).value || '';
        chips.forEach(function (c) { c.b.setAttribute('aria-pressed', c.b.getAttribute('data-ui-fabric') === name ? 'true' : 'false'); });
      });
    }
  }

  /* accessory groups: the existing summary already shows "N options" and the engine's "N selected · +$X" (data-acc-summary) — no second badge */

  /* ---------------- accessory quick view ----------------
     Plain clicks on an optional-accessory card open a drawer with the accessory's own product data (/products/<handle>.js)
     and an Add/Remove button that clicks the card's REAL toggle — the full product page stays one link away and still
     opens on modifier-click / middle-click / when JS or the fetch fails. */
  var qv = null;
  var escapeHtml = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  panel.querySelectorAll('a.ame-customize__accessory-link[href*="/products/"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || typeof HTMLDialogElement !== 'function') return;
      e.preventDefault();
      var card = a.closest('[data-accessory-card]'); var toggle = card && card.querySelector('[data-addon-checkbox]');
      if (!qv) {
        qv = document.createElement('dialog'); qv.className = 'ui-drawer ui-drawer--qv'; qv.setAttribute('aria-labelledby', 'ui-qv-title');
        qv.innerHTML = '<div class="ui-drawer__head"><h2 class="ui-drawer__title" id="ui-qv-title">Accessory details</h2><button type="button" class="ui-drawer__close" data-ui-close aria-label="Close">×</button></div>' +
          '<div class="ui-drawer__body" data-qv-body></div><div class="ui-drawer__foot"><a class="ui-btn ui-btn--tertiary" data-qv-link href="#">Full product page</a><button type="button" class="ui-btn ui-btn--primary" data-qv-toggle></button></div>';
        document.body.appendChild(qv);
        qv.addEventListener('click', function (ev) { if (ev.target === qv || ev.target.closest('[data-ui-close]')) qv.close(); });
        qv.addEventListener('close', function () { if (qv._from) qv._from.focus(); });
      }
      qv._from = a;
      var body = qv.querySelector('[data-qv-body]'), tbtn = qv.querySelector('[data-qv-toggle]');
      qv.querySelector('[data-qv-link]').href = a.href;
      body.innerHTML = '<p class="ui-secondary">Loading…</p>';
      var setBtn = function () {
        if (!toggle) { tbtn.hidden = true; return; }
        tbtn.hidden = false; tbtn.disabled = toggle.disabled;
        tbtn.textContent = toggle.getAttribute('aria-pressed') === 'true' ? 'Remove from configuration' : 'Add to configuration';
      };
      tbtn.onclick = function () { if (toggle && !toggle.disabled) { toggle.click(); setBtn(); syncAll(); } };
      setBtn(); qv.showModal();
      fetch(a.pathname.replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
        var img = (p.featured_image || (p.images || [])[0] || '');
        if (img) img = (img.indexOf('//') === 0 ? 'https:' + img : img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=560';
        var desc = String(p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        if (desc.length > 700) desc = desc.slice(0, 700).replace(/\s+\S*$/, '') + '…';
        body.innerHTML = (img ? '<img class="ui-qv__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" width="560" height="560" loading="lazy">' : '') +
          '<h3 class="ui-h3">' + escapeHtml(p.title) + '</h3>' +
          '<p class="ui-qv__price">' + (p.price_varies ? 'From ' : '') + money(p.price) + '</p>' +
          (desc ? '<p class="ui-secondary">' + escapeHtml(desc) + '</p>' : '');
      }).catch(function () { qv.close(); window.location.href = a.href; });
    });
  });

  /* ---------------- keep every proxy in step with the engine ---------------- */
  panel.addEventListener('change', syncAll, true);
  panel.addEventListener('click', syncAll, true);
  document.addEventListener('ame:pdp:state', syncAll);
  document.addEventListener('ame:variant-change', syncAll);
  syncAll();
})();
